import React, { useEffect, useState } from "react";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import i18n from "i18next";
import { useNavigate } from "react-router-dom";
// Fluent UI Imports
import AddEditEmailTemplate from "./AddEditEmailTemplate";

import { baseUrl } from "../../../helpers/constants";
import { IEmailTemplate } from "../../../Models/IEmailTemplate";
import { EmailTemplateColumns } from "./EmailTemplateColumns";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { Button, Tab, TabList } from "@fluentui/react-components";
import {
  AddRegular,
  FolderMailRegular,
  IosArrowRtl24Regular,
  SaveRegular,
} from "@fluentui/react-icons";
import { deepEqual } from "../../../helpers/deepEqual";
import Header from "../../Layout/Header";
import useWindowSize from "../../../helpers/useWindowSize";
import HeaderTextAnimation from "../../Layout/HeaderTextAnimation";

function EmailTemplates() {
  const windowSize = useWindowSize();
  const [returnedTemplate, setUpdatedTemplate] = useState<IEmailTemplate>();
  const [selectedTabValue, setSelectedTabValue] = useState<string>("HTML");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const emptyTemplate: IEmailTemplate = {
    name: "NEU",
    sprache: "de",
    subject: "NEU",
    content: "<p>Neues Template</p>",
    emailTemplateGuid: "",
    contentBody: "",
    isDeleted: false,
  };
  const [templates, setTemplates] = useState<IEmailTemplate[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<IEmailTemplate>();

  // Initial alle Templates laden
  useEffect(() => {
    getTemplates();
  }, []);
  useEffect(() => {
    if (templates) {
      if (window.location && window.location.search.includes("guid")) {
        if (window.location.search) {
          var search = window.location.search.split("=");
          var guid = search[1];
          if (guid) {
            setSelectedTemplate(
              templates.find((x: IEmailTemplate) => x.emailTemplateGuid == guid)
                ? templates.find((x) => x.emailTemplateGuid == guid)
                : undefined,
            );
          }
        } else {
          setSelectedTemplate(undefined);
        }
      } else if (window.location.search.includes("newTemplate")) {
        setSelectedTemplate(emptyTemplate);
      } else {
        setSelectedTemplate(undefined);
      }
    }
  }, [templates, window.location.search]);

  const getTemplates = () => {
    fetchWrapper.get(`${baseUrl}/api/emailtemplate/get`).then((result: any) => {
      setTemplates(result);
    });
  };
  const columns = EmailTemplateColumns({
    onClickedEmailTemplate: (item: IEmailTemplate) => {
      navigate("/admin/emailtemplates?guid=" + item.emailTemplateGuid);
    },
  });
  const onSaveTemplate = () => {
    if (returnedTemplate) {
      if (
        returnedTemplate.name &&
        returnedTemplate.sprache &&
        returnedTemplate.subject &&
        returnedTemplate.content
      ) {
        // Ok ich darf speichern
        if (returnedTemplate.emailTemplateGuid) {
          //Update
          fetchWrapper
            .post(baseUrl + "/api/emailtemplate/update", returnedTemplate)
            .then((result: any) => {
              setSuccessMessage(result.message);
              setUpdatedTemplate(undefined);
              getTemplates();
            })
            .catch((error: any) => {
              setErrorMessage(error);
            });
        } else {
          //Neu
          fetchWrapper
            .post(baseUrl + "/api/emailtemplate/add", returnedTemplate)
            .then((result: any) => {
              setSuccessMessage(result.message);
            })
            .catch((error: any) => {
              setErrorMessage(error);
            });
        }
      }
    }
  };

  return (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            {(windowSize.width > 1500 ||
              windowSize.width < 1024 ||
              !selectedTemplate) && (
              <Button
                icon={<FolderMailRegular fontSize={24} color="#ff6600" />}
                size="large"
                appearance="subtle"
                onClick={() => {
                  navigate("/admin/emailtemplates");
                  setSelectedTemplate(undefined);
                }}
              >
                {i18n.t<string>("emailTemplates").toLocaleUpperCase()}
              </Button>
            )}
            {windowSize.width < 1501 &&
              windowSize.width > 1024 &&
              selectedTemplate && (
                <Button
                  style={{ paddingLeft: "0px" }}
                  size="small"
                  onClick={() => {
                    navigate("/admin/emailtemplates");
                    setSelectedTemplate(undefined);
                  }}
                  appearance="transparent"
                >
                  <FolderMailRegular fontSize={24} color="#ff6600" />
                </Button>
              )}
            {selectedTemplate && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button size="large" appearance="subtle">
                  <HeaderTextAnimation text={selectedTemplate.subject} />
                </Button>
              </div>
            )}
          </StackShim>
        }
      />

      <div className="lueb-InnerContentBlockPadding2px">
        {!selectedTemplate && (
          <Button
            icon={<AddRegular />}
            appearance="transparent"
            onClick={() => {
              navigate("/admin/emailtemplates?newTemplate");
            }}
          >
            Template hinzufügen
          </Button>
        )}
        {selectedTemplate && (
          <Button
            appearance="transparent"
            icon={<SaveRegular />}
            disabled={deepEqual(returnedTemplate, selectedTemplate)}
            onClick={() => {
              getTemplates();
              onSaveTemplate();
            }}
          >
            {i18n.t<string>("save")}
          </Button>
        )}
      </div>
      {selectedTemplate && (
        <TabList
          /* defaultSelectedValue={"HTML"} */
          selectedValue={selectedTabValue}
          onTabSelect={(ev, tab) => {
            if (typeof tab.value == "string") {
              setSelectedTabValue(tab.value);
            }
          }}
          style={{ marginBottom: "5px" }}
        >
          <Tab value="HTML">HTML</Tab>
          <Tab value="vorschau">{i18n.t<string>("vorschauPic")}</Tab>
        </TabList>
      )}
      <div className="lueb-ContentBlock">
        {!selectedTemplate && (
          <LuebPagedDataGrid
            columns={columns}
            items={templates}
            resizableColumns
            sortable
            columnSizingOptions={{
              name: { defaultWidth: 250, minWidth: 150 },
              sprache: { defaultWidth: 100, minWidth: 50 },
              subject: { defaultWidth: 200, minWidth: 50 },
            }}
          />
        )}
        {selectedTemplate && (
          <AddEditEmailTemplate
            newTemplate={(item: IEmailTemplate) => {
              setUpdatedTemplate(item);
            }}
            selectedTab={selectedTabValue}
            template={selectedTemplate}
          />
        )}
      </div>
    </div>
  );
}

export default EmailTemplates;
